import { render, staticRenderFns } from "./ContactDistributionsByOwner.vue?vue&type=template&id=a308a0ba&scoped=true"
import script from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByOwner.vue?vue&type=style&index=0&id=a308a0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308a0ba",
  null
  
)

export default component.exports